import React from 'react';
import Header from './ContactComponents/Header';

const AddContact = () => {
    return <Header />;
};

export default AddContact;
